import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import Inspections from "./Inspections.jsx";
import InspectionDetail from "./InspectionDetail.jsx";

class InspectionRoutes extends Component {
  render() {
    return (
      <Switch>
        <Route exact path="/inspections" component={Inspections} />
        <Route exact path="/inspections/:iId" component={InspectionDetail} />
      </Switch>
    );
  }
}

export default InspectionRoutes;



// WEBPACK FOOTER //
// ./src/views/Inspections/InspectionRoutes.js